import $ from 'jquery';

$(function () {
  window.Application.scrollFocus = function (jqueryElement, duration, easing, callback) {
    var elemTop;
    elemTop = jqueryElement.offset().top - 16 - 56;
    if (elemTop < $(window).scrollTop()) {
      return $('html, body').animate(
        {
          scrollTop: elemTop,
        },
        duration,
        easing,
        function () {
          if (jqueryElement.attr('id') !== 'booking-work-date') {
            jqueryElement.focus();
          }
          if (callback) {
            return callback();
          }
        },
      );
    } else {
      if (jqueryElement.attr('id') !== 'booking-work-date') {
        jqueryElement.focus();
      }
      if (callback) {
        return callback();
      }
    }
  };
});
